import React from 'react'
import {
   Cancel as CancelIcon,
} from 'iconoir-react'
import { styled } from 'linaria/react'
import { css } from 'linaria'
import Title from '../../Core/Title'
import VbDrawer from '../../Core/VbDrawer'
import { theme } from '../../Theme'
import { useIntl } from '@jetshop/intl'

const BOTTOM_FADE_HEIGHT = '1rem'

const DrawerOverride = css`
   border-radius: 1.5rem 0rem 0rem 1.5rem !important;
   ${theme.below.xl} {
      padding-left: 1rem !important;
      padding-right: 1.5rem !important;
      padding-top: 1rem !important;
      padding-bottom: 0rem !important;
   }
   overflow: hidden;
`

const MobileDrawerContainer = styled.div`
   flex-direction: column;
   height: 100%;
   display: flex;

   &::after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: ${BOTTOM_FADE_HEIGHT};
      background: linear-gradient(
         to bottom,
         rgba(255, 255, 255, 0) 0%,
         #ffffff 100%
      );
      pointer-events: none;
   }
   &.hide-fade.category-tag-filters-container::after {
      opacity: 0;
      transition: opacity 0.12s ease-in-out;
   }

   .cancel-icon {
      margin-bottom: 2px;
   }

   &.page-hidden {
      display: none !important;
   }

   &.page-visible {
      animation: growDown 250ms ease-in-out forwards;
      transform-origin: right center;
   }

   // Override child comp label fontsize
   .form-check-label {
      font-size: 14px;
   }

   @keyframes growDown {
      from {
         transform: translateX(100%);
      }
      to {
         transform: translateX(0%);
      }
   }
`

const MobileCategoryContent = styled.div`
   border-top: 1px solid #dcdcdc;
   border-bottom: 1px solid #dcdcdc;
   margin-right: -1.5rem;
   margin-left: -1rem;
   flex: 1 1 0%;
   padding: 0 1rem ${BOTTOM_FADE_HEIGHT} 1rem;
   border-bottom: 'none';
   overflow-y: auto;
   position: relative;
`

const MobileFilterDrawer = ({
   isOpen,
   setIsOpen,
   title,
   children,
   ...props
}) => {
   const t = useIntl()
   return (
      <VbDrawer
         isOpen={isOpen}
         setIsOpen={setIsOpen}
         backgroundColor={'white'}
         overrideDefault={true}
         direction="right"
         className={DrawerOverride}
      >
         <MobileDrawerContainer {...props}>
            <>
               <div className="row mb-16">
                  <div className="col-1"></div>
                  <div className="col-9 d-flex justify-content-center align-items-center">
                     <Title size="18px" weight={700} fontFamily="Industry">
                        {title}
                     </Title>
                  </div>
                  <div className="col-2 d-flex justify-content-end">
                     <CancelIcon
                        strokeWidth={2.0}
                        width={32}
                        height={32}
                        className="cancel-icon"
                        onClick={() => setIsOpen(!isOpen)}
                     ></CancelIcon>
                  </div>
               </div>
               <MobileCategoryContent>{children}</MobileCategoryContent>
               {/* <MobileDrawerFooter className="px-32 py-64"></MobileDrawerFooter> */}
            </>
         </MobileDrawerContainer>
      </VbDrawer>
   )
}
export default MobileFilterDrawer